import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  IconButton,
  RadioGroup,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import * as DeviceSelectors from "../../store/Device/selectors";
import {
  addDevice,
  getDeviceType,
  setDeviceType,
  updateDevice,
} from "../../store/Device/actions";
import * as MachineSelector from "../../store/Machine/selectors";

function MoveDevise({ open, setOpen }) {
  const dispatch = useDispatch();

  const [sn, setSn] = useState("");
  const [imei, setImei] = useState("");

  const machine_info = useSelector(MachineSelector.machine_info);

  useEffect(() => {
    dispatch(getDeviceType());

    return () => {
      dispatch(setDeviceType([]));
    };
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  const handleUpdate = () => {
    let body = {
      nomer: machine_info.nomer,
      imei: imei,
      typeCom: "SWAP_DEVICE",
    };
    dispatch(updateDevice(body));

    setOpen(false);
    setImei("");
  };

  return (
    <Dialog open={open} onClose={() => handleClose(false)}>
      <DialogTitle>
        Заменить устройство
        <IconButton
          aria-label="close"
          onClick={() => handleClose(false)}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <FormControl>
          <TextField
            margin="dense"
            label="Imei"
            type="text"
            fullWidth
            variant="outlined"
            value={imei}
            onChange={(e) => setImei(e.target.value)}
          />
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => handleUpdate(false)}>Добавить</Button>
      </DialogActions>
    </Dialog>
  );
}

export default MoveDevise;
